<shared-draggable-dialog-header>
  <h1 class="dialog-title">
    Secure Message with Patient <a href="/users/{{patientId()}}">{{ patientSummary()}} </a>
  </h1>
  <div class="header-actions">
    <button class="btn-link" (click)="hideSystemMessages = !hideSystemMessages">
      {{ hideSystemMessages ? 'Show' : 'Hide' }} system messages
    </button>
    <button class="btn-link" (click)="markAsRead()">Mark as read</button>
  </div>
</shared-draggable-dialog-header>

<div class="dialog-body chat-box">
  @if (isLoading() && messages().length === 0) {
    <div class="loading-state">Loading messages...</div>
  }

  @for (msg of messages(); track msg.id) {
    @if (!shouldHide(msg)) {
      <messaging-message-bubble
        [message]="msg"
        [contentHtml]="(msg | messageContent).html"
        [widgets]="(msg | messageContent).widgets"
        [patientId]="patientId()"
        [senderType]="getSenderType(msg)"
        [showActions]="true"
        [categories]="categories()"
        (categoryChange)="updateCategory($event.messageId, $event.categoryId)"
        (readToggle)="toggleReadStatus($event.messageId, $event.readAt)"
      />
    }
  }

  @if (!isLoading() && messages().length === 0) {
    <h5 class="empty-state">No conversation history.</h5>
  }
</div>

<div class="dialog-footer">
  <form (ngSubmit)="sendMessage()">
    <textarea
      class="form-control"
      [formControl]="messageForm"
      name="message"
      placeholder="Type your message here..."
      rows="3"
    ></textarea>
    <button class="btn btn-success" type="submit" [disabled]="sending() || messageForm.invalid">Send</button>
  </form>
</div>
